export default __webpack_public_path__ + "static/media/walletMetamask.71e143d7.png";